import { dropLast, last, pipe, reduce, reduced, split } from 'ramda'

export const dateFormat = 'YYYY-MM-DD' as const
export const monthFormat = 'YYYY-MM' as const
export const isMonthly = (date: string) => /^\d+(-|\.)\d+$/.test(date)

export const params = {
  schoolType: 'schoolType',
  date: 'date',
  studentID: 'id',
  studentId: 'id',
  classID: 'klassId',
  classId: 'klassId',
  summary: 'summary',
  supplierID: 'supplierId',
  supplierId: 'supplierId',
  section: 'section',
  periodFrom: 'from',
  periodTo: 'to',
  withdrawID: 'withdrawId',
  withdrawId: 'withdrawId',
  categoryID: 'categoryId',
  categoryId: 'categoryId',
} as const

type Params = typeof params

export const slug = (val: Params[keyof Params]) => `:${val}`

export const getDate = (prms: { [params.date]?: string }): string | undefined => prms[params.date]
export const getDateExact = (prms: { [params.date]: string }): string => prms[params.date]
export const getStudentIdExact = (prms: { [params.studentId]: string }): string =>
  prms[params.studentID]
export const getSchoolTypeExact = (prms: { [params.schoolType]: string }): string =>
  prms[params.schoolType]
export const getClassId = (prms: { [params.classId]?: string }): string | undefined =>
  prms[params.classID]
export const getIsSummary = (prms: { [params.summary]?: string }): string | undefined =>
  prms[params.summary]
export const getSupplierId = (prms: { [params.supplierId]?: string }): string | undefined =>
  prms[params.supplierID]
export const getSection = (prms: { [params.section]?: string }): string | undefined =>
  prms[params.section]
export const getPeriodFrom = (prms: { [params.periodFrom]?: string }): string | undefined =>
  prms[params.periodFrom]
export const getPeriodTo = (prms: { [params.periodTo]?: string }): string | undefined =>
  prms[params.periodTo]
export const getWithdrawId = (prms: { [params.withdrawId]?: string }): string | undefined =>
  prms[params.withdrawID]
export const getCategoryId = (prms: { [params.categoryId]?: string }): string | undefined =>
  prms[params.categoryId]

// ДНЕВНИК

export const dnevnikPathMask = `/apps/${slug(params.studentID)}/dnevnik/home/${slug(params.classID)}/${slug(params.date)}`

// ЖУРНАЛ

export const journalPathMask = `/apps/${slug(params.studentID)}/dnevnik/journal/${slug(params.classID)}/${slug(params.date)}/${slug(params.summary)}`

// СТОЛОВАЯ ****************

// root
export const cafeteriaBasePathMask = `/apps/${slug(params.studentID)}/cafeteria/${slug(params.schoolType)}`
// menu
export const cafeteriaMenuPathMask = `${cafeteriaBasePathMask}/menu/${slug(params.date)}/${slug(params.categoryID)}`
// заказы
export const cafeteriaOrdersPathMask = `${cafeteriaBasePathMask}/orders/${slug(params.date)}`
// заявки на класс
export const cafeteriaOrderRequestsPathMask = `${cafeteriaBasePathMask}/orderRequests/${slug(params.date)}`
// компенсации
export const cafeteriaCompensationPathMask = `${cafeteriaBasePathMask}/compensation/${slug(params.section)}/${slug(params.supplierID)}/${slug(params.periodFrom)}/${slug(params.periodTo)}/${slug(params.withdrawID)}`
// финансы
export const cafeteriaFinancesPathMask = `${cafeteriaBasePathMask}/finances/${slug(params.date)}`
// покупки
export const cafeteriaPurchasesPathMask = `${cafeteriaBasePathMask}/purchases/${slug(params.date)}`
// график питания
export const cafeteriaSchedulePathMask = `${cafeteriaBasePathMask}/schedule/${slug(params.date)}`
// дотации
export const cafeteriaSubsidiesPathMask = `${cafeteriaBasePathMask}/subsidies/${slug(params.date)}`

// **************** END СТОЛОВАЯ

export const createPath = (props: {}, mask: string) => {
  return pipe(
    split(':'),
    reduce((acc, val) => {
      if (!val) return acc
      const pathItems = val.split('/')
      const key = pathItems[0]
      if (key && props[key]) {
        pathItems[0] = props[key]
        return acc + pathItems.join('/')
      }
      if (key && !props[key]) {
        return reduced(last(acc) === '/' ? dropLast(1, acc) : acc)
      }
      return acc + val
    }, ''),
  )(mask)
}
